module.exports = __webpack_public_path__ + "img/iphone-map-SWEDEN-en.8a2ba25e.webp";